import { deleteBonusItem } from "@/api/bonus-items";
import { Button } from "@/components/ui/button";
import {
  BonusItem,
  BonusItemType,
  BonusItemTypeLabels,
} from "@/models/bonus-items.model";
import { ColumnDef } from "@tanstack/react-table";

const ActionCell = ({
  row,
  deleteBonusItemCallback,
}: {
  row: any;
  deleteBonusItemCallback: (id: number) => void;
}) => {
  const handleDeleteBonusItem = async () => {
    try {
      const res = await deleteBonusItem(row.original.id);

      if (res) {
        deleteBonusItemCallback(row.original.id);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <Button variant="outline" onClick={handleDeleteBonusItem}>
      Delete
    </Button>
  );
};
export const getColumns = (
  deleteBonusItem: (id: number) => void
): ColumnDef<BonusItem>[] => [
  {
    accessorFn: (row) => row.type,
    cell: ({ row }) => {
      return (
        <span>{BonusItemTypeLabels[row.original.type as BonusItemType]}</span>
      );
    },
    header: "Type",
  },
  {
    accessorFn: (row) => row.amount,
    cell: ({ row }) => {
      return <span>{row.original.amount}</span>;
    },
    header: "Amount ($)",
  },
  {
    header: "Actions",
    cell: ({ row }) => (
      <ActionCell deleteBonusItemCallback={deleteBonusItem} row={row} />
    ),
  },
];
